import { matchesChannelId } from './channelIdHelpers';

export const findListingEntity = (state, {
  masterProductId,
  channelId,
  listingProductId,
} = {}) => {
  if (listingProductId && state.entities?.listings?.[listingProductId]) {
    return state.entities.listings[listingProductId];
  }

  return Object.values(state.entities?.listings || {}).find((listing) => {
    if (!listing?._id) return false;
    if (masterProductId && listing.masterProductId !== masterProductId) return false;
    if (listingProductId && listing._id !== listingProductId) return false;
    if (channelId && !matchesChannelId(listing, channelId)) return false;
    return true;
  }) ?? null;
};

export const findListingVariantEntity = (state, masterVariantId, channelId) => (
  Object.values(state.entities?.listingVariants || {}).find(
    (listingVariant) => (
      listingVariant?.masterVariantId === masterVariantId
      && matchesChannelId(listingVariant, channelId)
    ),
  ) ?? null
);

export const listListingVariantsForChannel = (state, masterProductId, channelId) => {
  const product = state.items?.find(({ _id }) => _id === masterProductId);
  const masterVariantIds = new Set((product?.variants || []).map(({ _id }) => _id));

  return Object.values(state.entities?.listingVariants || {}).filter(
    (listingVariant) => (
      masterVariantIds.has(listingVariant?.masterVariantId)
      && matchesChannelId(listingVariant, channelId)
    ),
  );
};

export const listListingVariantIdsForChannel = (state, masterProductId, channelId) => (
  listListingVariantsForChannel(state, masterProductId, channelId)
    .map((variant) => variant._id)
    .filter(Boolean)
);

export const findListingVariantIndexEntry = (state, masterVariantId, channelId) => (
  Object.values(state.entities?.listingVariantIndex || {}).find(
    (row) => (
      String(row?.masterVariantId) === String(masterVariantId)
      && matchesChannelId(row, channelId)
    ),
  ) ?? null
);

export const listListingVariantIndexForChannel = (state, masterProductId, channelId) => (
  Object.values(state.entities?.listingVariantIndex || {}).filter(
    (row) => (
      String(row?.masterProductId) === String(masterProductId)
      && matchesChannelId(row, channelId)
    ),
  )
);

export const getListingProductIdFromState = (state, masterProductId, channelId) => (
  findListingEntity(state, { masterProductId, channelId })?._id ?? null
);
